module.exports = __webpack_public_path__ + "img/oncallair_logo.34d472fc.svg";